import React, { useState } from 'react';
import TabContent from '../../TabContent';
import AllDocs from './AllDocs';
import AddBookingType from './AddBookingType';
import BookingRequests from './BookingRequests';

const SUB_TABS = [
    {
        id: 'booking',
        title: 'Doctors List',
        icon: 'bi bi-person-badge',
        iconfill: 'bi bi-person-badge-fill',
    },
    {
        id: 'bookingType',
        title: 'Appointment Types',
        icon: 'bi bi-calendar2-check',
        iconfill: 'bi bi-calendar2-check-fill',
    },
    {
        id: 'bookingRequests',
        title: 'Booking Requests',
        icon: 'bi bi-calendar3-range',
        iconfill: 'bi bi-calendar3-range-fill',
    },
];

function BookingTab() {
    const [activeTab, setActiveTab] = useState('booking');

    return (
        <div className="clinic-booking-module">
            <div className="clinic-booking-module__header">
                <div>
                    <h5 className="clinic-booking__title mb-1">
                        <i className="bi bi-calendar3 text-primary me-1"></i>
                        Appointment Management
                    </h5>
                    <p className="text-muted small mb-0">
                        Manage doctors, appointment types, and incoming booking requests.
                    </p>
                </div>
            </div>

            <nav className="clinic-booking-subnav" aria-label="Appointment sections">
                {SUB_TABS.map((tab) => {
                    const isActive = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            type="button"
                            className={`clinic-booking-subnav__link ${isActive ? 'clinic-booking-subnav__link--active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                            aria-current={isActive ? 'page' : undefined}
                        >
                            <i className={isActive && tab.iconfill ? tab.iconfill : tab.icon}></i>
                            {tab.title}
                        </button>
                    );
                })}
            </nav>

            <div className="clinic-booking-content">
                <TabContent id="booking" activeTab={activeTab}>
                    <AllDocs />
                </TabContent>
                <TabContent id="bookingType" activeTab={activeTab}>
                    <AddBookingType />
                </TabContent>
                <TabContent id="bookingRequests" activeTab={activeTab}>
                    <BookingRequests />
                </TabContent>
            </div>
        </div>
    );
}

export default BookingTab;
